import { createBlueprint as t } from "@made-people/blueprint";
const l = t({
  slots: {
    base: "px-4 lg:px-[175px] py-8 flex flex-col items-start lg:grid lg:grid-cols-[60%_40%] lg:gap-x-5",
    heading: "text-heading-xs lg:text-heading-md mb-4",
    orderNumberLabel: "text-body-sm",
    orderNumber: "text-body-lg mb-4 ",
    body: "text-body-sm",
    button: "mt-4 text-body-sm",
    cartSummaryHeading: "text-heading-xs lg:text-heading-sm mb-4",
    cartSummaryWrapper: "lg:col-start-2 row-start-1 row-span-10 lg:mt-0 mt-10 rounded-lg bg-[#f3f3f3] p-6",
    hiddenLabel: "sr-only"
  },
  variants: {}
}), r = t({
  slots: {
    base: "lg:mt-4 col-start-1 py-4 text-body-sm border-b border-border",
    row: "flex flex-col my-2",
    label: "text-label-md font-bold",
    item: "text-body-sm",
    hiddenLabel: "sr-only"
  },
  variants: {}
}), a = t({
  slots: {
    base: "col-start-1 py-4 text-body-md border-b border-border",
    row: "flex flex-col my-2",
    label: "text-label-md font-bold",
    item: "text-body-md",
    hiddenLabel: "sr-only"
  },
  variants: {}
}), s = t({
  slots: {
    base: "px-4 py-8 flex flex-col items-start lg:grid lg:grid-cols-2 lg:gap-x-12"
  },
  variants: {}
}), o = t({
  slots: {
    base: "px-4 lg:px-[175px] py-8 flex flex-col items-start lg:grid lg:grid-cols-[60%_40%] lg:gap-x-   5",
    heading: "text-heading-xs lg:text-heading-md mb-4",
    orderNumberWrapper: "flex flex-row gap-2",
    orderNumberLabel: "text-body-sm",
    orderNumber: "text-body-lg mb-4 ",
    body: "text-body-sm",
    button: "mt-4 text-body-sm",
    cartSummaryHeading: "text-heading-xs lg:text-heading-sm mb-4",
    cartSummaryWrapper: "lg:col-start-2 row-start-1 row-span-10 lg:mt-0 mt-10 rounded-lg bg-[#f3f3f3] p-6",
    hiddenLabel: "sr-only"
  },
  variants: {}
});
export {
  s as a,
  o as b,
  r as o,
  a as p,
  l as s
};
//# sourceMappingURL=blueprint-1b85b4b5.mjs.map
